// Mock API functions - temporary code for testing refactored fields
// TO BE REMOVED after backend migration is complete

export const isMockMode = (searchParams = window.location.search) => {
    return searchParams.includes('mockAPI');
};

// Mock fetch function that returns test data
export const mockAuthenticatedFetch = (url, options) => {
    // Mock student data endpoint
    if (url.includes('/students/with-attendance-data/')) {
        return Promise.resolve({
            ok: true,
            json: async () => [{
                id: 1,
                nickname: "Test Student",
                daily_hours_required: 5,
                no_attendance_requirement: false,
                personal_days_used: 0,
                personal_days_allowed: 10,
                is_off_campus: false,
                warning_status: "",
                violations: [],
                attendance: null
            }]
        });
    }
    
    // Mock calendar endpoint
    if (url.includes('/calendar/for-day/')) {
        return Promise.resolve({
            ok: true,
            json: async () => ({
                holidays: [],
                first_day: "2024-09-01",
                last_day: "2025-06-15"
            })
        });
    }
    
    // Mock attendance save endpoints
    if (url.includes('/api/attendance') && (options?.method === 'POST' || options?.method === 'PUT')) {
        return Promise.resolve({
            ok: true,
            json: async () => ({ success: true })
        });
    }
    
    // Default response for unhandled endpoints
    return Promise.resolve({
        ok: false,
        json: async () => ({ error: 'Endpoint not mocked' })
    });
};